export default __webpack_public_path__ + "static/media/instagram.7eba5f81.svg";